module.exports = __webpack_public_path__ + "assets/cc3205d8a639d4f8c799fb411f31bd27.png";